<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h2>Contents</h2>
<ol>
<li><a href="#/nightmarecarnivalepub20#_idParaDest-1">Introduction</a></li>
<li><a href="#/nightmarecarnivalepub21#_idParaDest-2">Preface</a></li>
<li><a href="#/nightmarecarnivalepub22#_idParaDest-3">Scapegoats</a></li>
<li><a href="#/nightmarecarnivalepub23#_idParaDest-4">THE FIREBRAND </a></li>
<li><span href="#/nightmarecarnivalepub24#_idParaDest-5" title="Link target outside of Sample">WORK, HOOK, SHOOT, RIP </span></li>
<li><span href="#/nightmarecarnivalepub25#_idParaDest-6" title="Link target outside of Sample">AND THE CARNIVAL LEAVES TOWN </span></li>
<li><span href="#/nightmarecarnivalepub26#_idParaDest-7" title="Link target outside of Sample">CORPSE ROSE </span></li>
<li><span href="#/nightmarecarnivalepub27#_idParaDest-8" title="Link target outside of Sample">LAST OF THE FAIR </span></li>
<li><span href="#/nightmarecarnivalepub28#_idParaDest-9" title="Link target outside of Sample">A SMALL PART IN THE PANTOMIME </span></li>
<li><span href="#/nightmarecarnivalepub29#_idParaDest-10" title="Link target outside of Sample">HIBBLER’S MINIONS </span></li>
<li><span href="#/nightmarecarnivalepub30#_idParaDest-11" title="Link target outside of Sample">SWAN SONG AND THEN SOME </span></li>
<li><span href="#/nightmarecarnivalepub31#_idParaDest-12" title="Link target outside of Sample">THE LION CAGE </span></li>
<li><span href="#/nightmarecarnivalepub32#_idParaDest-13" title="Link target outside of Sample">THE DARKEST PART</span></li>
<li><span href="#/nightmarecarnivalepub33#_idParaDest-14" title="Link target outside of Sample">THE POPPING FIELDS </span></li>
<li><span href="#/nightmarecarnivalepub34#_idParaDest-15" title="Link target outside of Sample">SKULLPOCKET</span></li>
<li><span href="#/nightmarecarnivalepub35#_idParaDest-16" title="Link target outside of Sample">THE MYSTERIES </span></li>
<li><span href="#/nightmarecarnivalepub36#_idParaDest-17" title="Link target outside of Sample">SCREAMING ELK, MT </span></li>
<li><span href="#/nightmarecarnivalepub37#_idParaDest-18" title="Link target outside of Sample">ABOUT THE AUTHORS </span></li>
<li><span href="#/nightmarecarnivalepub38#_idParaDest-19" title="Link target outside of Sample">ABOUT THE EDITOR</span></li>
</ol>
</nav>
<nav epub:type="landmarks">
<h2>Landmarks</h2>
<ol>
<li><a epub:type="cover" href="#/cover">Cover</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?53ef519b